import { ERC20 } from 'src/common/types/models/Tokens'
import { InvestAssetsQuery as InvestAssetsQueryGQL } from '../types/swarm/graphql'
import { unifyAddress } from 'src/common/utils/web3/unifyAddress'

export const normalizeInvestAssetTokens = (
  data: InvestAssetsQueryGQL['assetTokens']
): ERC20[] => {
  return data.map(item => ({
    id: unifyAddress(item.id),
    contractAddress: item.id,
    name: item.name,
    symbol: item.symbol,
    logo: '',
    decimals: item.decimals,
    type: 'ERC20',
  }))
}
